/**
 * `openerFor` / `doubleClickAction` bound to the current plugin file-intake
 * list (ADR-030), so "Open in…" offers approved plugin apps (WordFlow,
 * SheetFlow, …) beside the internal arches, and re-renders when the list
 * arrives.
 */
import { useMemo } from 'react';
import { useFileIntakeArches } from '@/components/fias-ai/plugin-intake-directory';
import { doubleClickAction, openerFor } from '../lib/file-openers';

type OpenableFile = { mimeType: string | null; name: string };

export function useFileOpeners() {
  const pluginIntakes = useFileIntakeArches();
  return useMemo(
    () => ({
      openerFor: (file: OpenableFile) => openerFor(file, pluginIntakes),
      doubleClickAction: (file: OpenableFile) => doubleClickAction(file, pluginIntakes),
    }),
    [pluginIntakes],
  );
}
